import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router/dom"

import "@/lib/i18n"
import { Providers } from "@/app/providers"
import { router } from "@/app/router"
import { bootstrapSession } from "@/features/auth/session"
import "@/styles/globals.css"

void bootstrapSession()

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
